const BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// ── Token stored in sessionStorage ───────────────────────────────────
// sessionStorage is per-tab — each tab has its own independent session.
// This means you can open Restaurant A in Tab 1 and Restaurant B in Tab 2
// without them interfering with each other.

export function getToken() {
  return sessionStorage.getItem('qrmenu_token');
}

export function setToken(token) {
  sessionStorage.setItem('qrmenu_token', token);
}

export function clearToken() {
  sessionStorage.removeItem('qrmenu_token');
}

// ── Request helpers ───────────────────────────────────────────────────
async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${BASE}/api${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || 'Request failed');
  return data;
}

async function upload(path, formData) {
  const headers = {};
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${BASE}/api${path}`, {
    method: 'POST',
    headers,
    body: formData,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || 'Upload failed');
  return data;
}

export const api = {
  get:    (path)        => request('GET',    path),
  post:   (path, body)  => request('POST',   path, body),
  put:    (path, body)  => request('PUT',    path, body),
  delete: (path)        => request('DELETE', path),
  upload: (path, fd)    => upload(path, fd),
};